<template>
  <div @click="handleClick" class="button-outlined">{{text}}</div>
</template>

<script>
export default {
  props: {
    text: [String, Number]
  },
  methods: {
    handleClick() {
      this.$emit("clicked");
    }
  }
};
</script>

<style scoped>
.button-outlined {
  border: 2px solid #eddb51;
  border-radius: 10px;
  height: 45px;
  max-width: 202px;
  width: 202px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "OpenSans-SemiBold";
  font-size: 12px;
  color: #eddb51;
  margin-top: 8px;
  cursor: pointer;
  z-index: 1000;
  transition: 0.3s;
  box-shadow: 0px 2px 4px #000000, inset 0px 1px 3px #000000;
}

.button-outlined:hover {
  background-color: #eddb51;
  color: #17181a;
}
</style>